import { lineItemPropStrings } from '~/lib/constants';
import { formatDate, getWeekdayName } from './calendar-utils';
import { getCartItemProperties, getCartObject } from './cart-utils';

export const isDeliverySurcharge = (day, feeDays) => {
  return feeDays.includes(getWeekdayName(day));
};

// [date] - is in a javascript date object format
// [feeDates] - is an array of strings - ['23-10-2024', '25-10-2024']
export const isFeeDate = (date, feeDates) => {
  const formattedDate = formatDate({ date });
  return feeDates.includes(formattedDate);
};

// [date] - is in a javascript date object format
export const checkForFee = (date) => {
  const matchingFees = [];
  const feePrecedence = window.Boarderie.feePrecedence;
  // feePrecedence is a global variable and can be 'first-fee' or 'second-fee'

  // Check if the date is a delivery surcharge day
  const deliverySurchargeDays = window.Boarderie.deliverySurcharge?.days;
  const deliverySurchargeProduct = window.Boarderie.deliverySurcharge?.product;
  const deliverySurchargeColor = window.Boarderie.deliverySurcharge?.color;
  if (deliverySurchargeDays && deliverySurchargeProduct && isDeliverySurcharge(date, deliverySurchargeDays)) {
    matchingFees.push({
      type: 'deliverySurcharge',
      product: deliverySurchargeProduct,
      color: deliverySurchargeColor,
    });
  }

  // Check if the date is a first fee day
  const firstFeeDates = window.Boarderie.firstFee.dates;
  const firstFeeProduct = window.Boarderie.firstFee.product;
  const firstFeeColor = window.Boarderie.firstFee.color;
  if (firstFeeDates && firstFeeProduct && isFeeDate(date, firstFeeDates)) {
    matchingFees.push({
      type: 'firstFee',
      product: firstFeeProduct,
      color: firstFeeColor,
    });
  }

  // Check if the date is a second fee day
  const secondFeeDates = window.Boarderie.secondFee.dates;
  const secondFeeProduct = window.Boarderie.secondFee.product;
  const secondFeeColor = window.Boarderie.secondFee.color;
  if (secondFeeDates && secondFeeProduct && isFeeDate(date, secondFeeDates)) {
    matchingFees.push({
      type: 'secondFee',
      product: secondFeeProduct,
      color: secondFeeColor,
    });
  }

  // If both first and second fee are present, remove the one with lower precedence
  const hasBothFirstAndSecondFee =
    matchingFees.some((fee) => fee.type === 'firstFee') && matchingFees.some((fee) => fee.type === 'secondFee');

  if (hasBothFirstAndSecondFee) {
    if (feePrecedence === 'first-fee') {
      matchingFees.splice(
        matchingFees.findIndex((fee) => fee.type === 'secondFee'),
        1
      );
    } else {
      matchingFees.splice(
        matchingFees.findIndex((fee) => fee.type === 'firstFee'),
        1
      );
    }
  }

  return matchingFees;
};

/**
 *
 * @param {Element} cartItem - Cart item element
 * @returns {Array} - Array of connected fee products
 */
export const getLineItemFeeProducts = (cartItem) => {
  const cartItems = cartItem.closest('cart-items') || cartItem.closest('cart-drawer-items');
  const cartObject = getCartObject(cartItems);
  const { properties } = getCartItemProperties(cartItem);

  if (properties && properties[lineItemPropStrings.feeProductAdded]) {
    const connectedFeeProduct = cartObject.items.filter(
      (item) =>
        item.properties[lineItemPropStrings.groupKey] === properties[lineItemPropStrings.groupKey] &&
        item.properties['_type'] === 'fee'
    );

    return connectedFeeProduct;
  } else {
    return [];
  }
};

/**
 *
 * @param {Element} cartItem - Cart item element
 * @returns {Array} - Array of connected fee products
 */
export const getLineItemObjectFeeProducts = (cartObject, cartItemObject) => {
  const { properties } = cartItemObject;

  if (properties && properties[lineItemPropStrings.feeProductAdded]) {
    const connectedFeeProduct = cartObject.items.filter(
      (item) =>
        item.properties[lineItemPropStrings.groupKey] === properties[lineItemPropStrings.groupKey] &&
        item.properties['_type'] === 'fee'
    );

    return connectedFeeProduct;
  } else {
    return [];
  }
};

export const getLineItemFeeProductsByKey = (groupKey) => {};

export const getSameCorporateGifts = (items, corporateGroupKey) => {
  return items.filter(
    (item) =>
      item.properties[lineItemPropStrings.corporateGroupKey] === corporateGroupKey &&
      item.properties[lineItemPropStrings.corporateGift]
  );
};

export const isPhysicalItem = (item) => {
  return (
    !item.properties[lineItemPropStrings.egift] &&
    !item.handle.includes('protection') &&
    !item.handle.includes('gift-card') &&
    item.properties[lineItemPropStrings.type] !== 'fee'
  );
};

export const getFeeProducts = (items) => {
  return items.filter((item) => item.properties[lineItemPropStrings.type] === 'fee');
};

export const hasFeeProducts = (item) => {
  return item.properties[lineItemPropStrings.feeProductAdded];
};
